// extracted by mini-css-extract-plugin
module.exports = {"VideoFrame":"VideoFrame__VideoFrame_3kkFq","pulsate":"VideoFrame__pulsate_Pxlbx","Poster":"VideoFrame__Poster_2e-L-"};